import { makeStyles } from '@material-ui/core';


export const labelSupplementStyles = makeStyles((theme) => ({
    labelLayout: {
        display: 'flex',
        alignItems: 'center',
        '&.full-width': {
            width: '100%',
            justifyContent: 'space-between',
        },
        '& .supplement-wrapper': {
            marginLeft: theme.spacing(.5),
            '& > div': {
                top: '2px', //This is a override of the component positioning
            },
        },
    },

}));



